import React from 'react';
import {
  Box,
  SwipeableDrawer,
  Typography,
} from '@mui/material';
import { drawerContainerStyles, drawerHeaderStyles } from '../styles/swipeableEdge';

const drawerBleeding = 56;
const headerHeight = 56;

const Puller = () => (
  <Box
    sx={{
      width: 40,
      height: 6,
      bgcolor: '#003C59',
      borderRadius: 3,
      position: 'absolute',
      top: 8,
      left: 'calc(50% - 20px)',
    }}
  />
);

const BottomDrawer = ({
  open,
  onOpen,
  onClose,
  title,
  children,
  height = '80vh',
  showPuller = true,
  keepMounted = true,
  paperProps = {},
}) => {
  const paperHeight = `calc(${height} - ${drawerBleeding}px)`;

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      disableSwipeToOpen={false}
      swipeAreaWidth={drawerBleeding}
      keepMounted={keepMounted}
      allowSwipeInChildren={true}
      ModalProps={{
        keepMounted,
      }}
      PaperProps={{
        sx: {
          height: paperHeight,
          overflow: 'visible',
          ...paperProps.sx,
        },
        ...paperProps,
      }}
    >
      <Box
        onClick={!open ? onOpen : undefined}
        sx={drawerContainerStyles(open, drawerBleeding)}
      >
        <Box
          sx={drawerHeaderStyles(headerHeight)}
        >
          {showPuller && <Puller />}
          {title && (
            <Typography
              variant="subtitle1"
              sx={{
                mt: showPuller ? 1.5 : 0,
                fontWeight: 700,
                color: '#003C59',
              }}
            >
              {title}
            </Typography>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          px: 2,
          pb: 3,
          pt: 1,
          height: '100%',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          boxSizing: 'border-box',
          // backgroundColor: '#003C59',
        }}
      >
        {children}
      </Box>
    </SwipeableDrawer>
  );
};

export default BottomDrawer;